import { render, staticRenderFns } from "./AdSets.vue?vue&type=template&id=bca25d62&"
import script from "./AdSets.vue?vue&type=script&lang=js&"
export * from "./AdSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports